import { Card, Flex, Spin, Typography } from "antd"
import { Trans, useTranslation } from "react-i18next"
import { useSelector } from "react-redux"

//import InputNumber from '../../../../Components/Input/InputNumber'
import RiskBar, {
  getRiskLevel,
  getRiskTextColor,
  RISK_DESCRIPTIONS,
  RISK_LEVEL_TEXT
} from "./components/RiskBar"

const { Title, Text, Paragraph } = Typography

export const ProcessorRiskLevel = () => {
  const { t } = useTranslation()
  const { is_business_health_available } = useSelector((state) => state.health.mainInfo)
  const riskLevelFetching = useSelector((state) => state.health.riskLevelFetching)
  let riskLevel = useSelector((state) => state.health.riskLevel)
  if (!is_business_health_available) riskLevel = "0.00"

  //const [riskLevel, setRiskLevel] = useState(0)
  const riskStatus = null
  const currentRiskLevel = riskStatus || getRiskLevel(riskLevel)

  return (
    <Spin spinning={riskLevelFetching}>
      <Card
        style={{ borderRadius: "16px", height: "100%" }}
        styles={{ body: { padding: "16px", height: "100%" } }}
      >
        <Flex vertical gap={24} style={{ height: "100%" }}>
          <div>
            <Title
              level={5}
              style={{
                marginBottom: 8,
                lineHeight: "20px",
                fontWeight: 600,
                fontSize: "16px"
              }}
            >
              {t("Processor Risk Level")}
            </Title>
            <Text type="secondary">
              {t(
                "Maintaining a low chargeback rate helps ensure uninterrupted payment processing and lowers your risk level."
              )}
            </Text>
          </div>
          <div>
            <Flex justify="space-between" align={"start"}>
              <Title
                level={2}
                style={{
                  fontSize: 20,
                  lineHeight: "24px",
                  fontWeight: 600,
                  marginBottom: 16,
                  textAlign: "left"
                }}
              >
                {riskLevel}%
              </Title>
              {/*<InputNumber size="small" min={0} max={100} step={0.1} value={riskLevel} onChange={v => setRiskLevel(v)} />*/}
            </Flex>

            <RiskBar riskValue={riskLevel} isEmpty={!is_business_health_available} />
          </div>
          <div style={{ marginTop: "auto" }}>
            <Paragraph style={{ marginBottom: 4 }} strong>
              {is_business_health_available && (
                <Trans
                  i18nKey={"You are currently on a <1>{{riskLevel}}</1> level"}
                  riskLevel={RISK_LEVEL_TEXT[currentRiskLevel]}
                >
                  You are currently on a{" "}
                  <Text
                    type={getRiskTextColor(currentRiskLevel)}
                    strong
                    style={{ textTransform: "lowercase" }}
                  >
                    {RISK_LEVEL_TEXT[currentRiskLevel]}
                  </Text>{" "}
                  level
                </Trans>
              )}
              {!is_business_health_available && t("Connect Stripe to access this widget")}
            </Paragraph>
            {is_business_health_available && (
              <Text type="secondary">{RISK_DESCRIPTIONS[currentRiskLevel]}</Text>
            )}
            {!is_business_health_available && (
              <Text type="secondary" strong>
                This widget is only available to users with an active Stripe connection. To view
                detailed payment and dispute information, please connect your Stripe account.
              </Text>
            )}
          </div>
        </Flex>
      </Card>
    </Spin>
  )
}
